import AtlasImage from './atlas-image';

export default AtlasImage;
